import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { unfavoriteModelAction, changeCameraModelAction } from 'actions/cameraActions'
import { checkOfflineLimitsAction } from 'actions/applicationActions'
import equals from 'ramda/src/equals'

class Favorite extends React.Component {
  state = { favorited: this.props.favoriteModels.includes(this.props.id) }

  favOrUnfavModel = _ => {
    this.state.favorited
    ? this.props.unfavoriteModelAction(this.props.id)
    : this.props.checkOfflineLimitsAction('favoriteModel', [this.props.id])
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ favorited: nextProps.favoriteModels.includes(nextProps.id) })
  }

  render() {
    const { props: { classes, permalink }, state: { favorited }, favOrUnfavModel } = this

    if (permalink) return null
    return (
      <div onClick={favOrUnfavModel}>
        { favorited
          ? <FontAwesomeIcon icon='star' className={classes.favorited} />
          : <FontAwesomeIcon icon={['far', 'star']} className={classes.notFavorited} />
        }
      </div>
    )
  }
}

const SelectCameraButton = ({ aov, single, selectedCamera, initialCamera, initialAoV, changeCameraModelAction, applySingle, close, classes }) =>
  <div style={{ display: 'flex' }}>
    <div
      onClick={_ => {
        changeCameraModelAction(selectedCamera, aov, applySingle)
        close()
      }}
      className={classes.aovButton}
    >
      { (selectedCamera.form_factor || '').toLowerCase() === 'multi-imager' ? 'Select Multi-Imager' : (aov ? aov.range_text : 'Select Variable Lens') }
    </div>
    { equals(initialCamera)(selectedCamera) && (single || equals(aov, initialAoV)) && <FontAwesomeIcon icon='check' className={classes.current} /> }
  </div>

const mapStateToProps = ({ favoriteModels, permalink }) => ({ favoriteModels: favoriteModels || [], permalink })

class CameraDetails extends React.Component {
  render() {
    const { selectedCamera, updateCameraList, classes } = this.props
    const { id, image_url, model, manufacturer, ndaa_compliant, resolution_name, form_factor, aovs, infrared, super_low_light, imager_count, multi_imager_type } = selectedCamera

    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <div onClick={_ => updateCameraList(null)}>
            <FontAwesomeIcon icon='chevron-left' className={classes.backButton} />
            Models
          </div>
        </div>
        <div className={classes.body}>
          <div className={classes.row}>
            <div className={classes.text}>
              <p style={{ fontSize: '1.8rem' }}>{ manufacturer }</p>
              <p>{ model }</p>
              <Favorite id={id} {...this.props} />
            </div>
            { image_url &&
              <div className={classes.imageWrapper}>
                <img src={image_url} className={classes.image} />
              </div>
            }
          </div>
          <div className={classes.rowSelector}>
            <table className={classes.table} cellSpacing='0'>
              { (form_factor || '').toLowerCase() === 'multi-imager'
                ? <tbody>
                    <tr><td>Form</td><td>{form_factor}</td></tr>
                    <tr><td>Imager Count</td><td>{imager_count}</td></tr>
                    <tr><td>Multi-Imager Type</td><td>{multi_imager_type}</td></tr>
                    <tr><td>NDAA Compliant</td><td>{ndaa_compliant ? 'Yes' : 'No'}</td></tr>
                  </tbody>
                : <tbody>
                    <tr><td>Form</td><td>{form_factor}</td></tr>
                    <tr><td>Resolution</td><td>{ resolution_name.match('12MP 270°') ? '12 MP' : resolution_name }</td></tr>
                    <tr><td>IR</td><td>{infrared > 0 ? `${infrared}m` : 'None'}</td></tr>
                    { super_low_light && <tr><td>Super Low Light</td><td>Yes</td></tr> }
                    <tr><td>NDAA Compliant</td><td>{ndaa_compliant ? 'Yes' : 'No'}</td></tr>
                  </tbody>
              }
            </table>
            <div>
              <div className={classes.text}>
                Select Lens:
              </div>
              { aovs.length <= 1
                ? <SelectCameraButton aov={ aovs.length === 1 ? aovs[0] : null } single { ...this.props } />
                : aovs.map(aov => <SelectCameraButton aov={aov} { ...this.props } key={aov.range_text} />)
              }
            </div>
          </div>

        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { checkOfflineLimitsAction, unfavoriteModelAction, changeCameraModelAction })(injectSheet(style)(CameraDetails))



// WEBPACK FOOTER //
// ./src/components/BottomBar/ModelSelector/CameraDetails/index.js